import React from 'react';
import { Typography, Container, Box, Stack, Grid, Link } from '@mui/material';
import { Link as RLink } from "react-router-dom";
import { Localized } from '@fluent/react';
import { useRecoilValue } from 'recoil';
import { trafficSourceState } from '../../state';
import { getTelegramBotLink } from '../../utils/trafficSource';

export function Footer() {
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);

  return (
    <Box component="footer" sx={{ bgcolor: 'rgba(0, 0, 0, 0.1)', py: 6 }}>
      <Container maxWidth="lg">
        <Typography variant="h6" align="center" gutterBottom>
          <Localized id="footer_title">
            UCard Bot | Crypto Visa Cards
          </Localized>
        </Typography>
        <Typography
          variant="subtitle1"
          align="center"
          color="text.secondary"
          component="p"
        >
          <Localized id="footer_subtitle">
            Ваш мост между криптовалютой и реальным миром.
          </Localized>
        </Typography>

                
        {/* Contact Information */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, flexDirection: 'column', alignItems: 'center' }}>
          {/* <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
            <Localized id="footer_contact_us">
              Contact Us
            </Localized>
          </Typography> */}
          <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Typography variant="subtitle1">
              <Localized id="footer_telegram_label">
                Telegram:
              </Localized>
              {' '}
              <Link
                color="inherit"
                href={telegramBotLink}
                target="_blank"
                rel="noopener noreferrer">
                @ucardonebot
              </Link>
            </Typography>
            <Typography variant="subtitle1">
              <Link
                color="inherit"
                href="mailto:contact@ucard.one"
                target="_blank"
                rel="noopener noreferrer">
                contact@ucard.one
              </Link>
            </Typography>
          </Box>
        </Box>

        {/* Footer Links */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, flexWrap: 'wrap' }}>
          <Link as={RLink} to="/privacy" color="inherit" sx={{ mx: 1.5 }}>
            <Localized id="footer_privacy_policy">
              Политика конфиденциальности
            </Localized>
          </Link>
          <Link as={RLink} to="/terms" color="inherit" sx={{ mx: 1.5 }}>
            <Localized id="footer_terms_of_service">
              Условия использования
            </Localized>
          </Link>
          <Link as={RLink} to="/aml" color="inherit" sx={{ mx: 1.5 }}>
            <Localized id="footer_aml_policy">
              AML-политика
            </Localized>
          </Link>
        </Box>


        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mt: 4 }}
        >
          {'© '}
          {new Date().getFullYear()}
          {' UCard. Все права защищены.'}
        </Typography>
      </Container>
    </Box>
  );
}


export function Footer2() {
  const trafficSource = useRecoilValue(trafficSourceState);
  const telegramBotLink = getTelegramBotLink(trafficSource);

  return (

    <Stack
      component="footer"
      direction="column"
      spacing={3}
      alignItems={'center'}
      sx={{
        py: 2,
        px: 2,
        background: '#00000022',
        backdropFilter: 'blur(5px)',
        boxShadow: '0px -1px 10px 0px #00000044',
      }}>

      <Container sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={2}
          justifyContent={'space-evenly'}>

          {/* <Grid item xs={5} sm={2} md={2}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                ml: { xs: 3 },
                color: 'text.secondary',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
                // alignItems: 'flex-start',
                // flexGrow: 1,
                // flexBasis: '30%',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Links
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/">
                  Features
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/">
                  FAQ
                </Link>
              </Typography>
            </Stack>
          </Grid> */}

          {/* <Grid item xs={6} sm={3} md={3}>
            <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.secondary',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Legal
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/terms">
                  Terms of Service
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  as={RLink}
                  to="/privacy">
                  Privacy Policy
                </Link>
              </Typography>
            </Stack>
          </Grid> */}

          {/* <Grid item xs={0} sm={2} md={3}> */}
          {/* <Stack
              direction="column"
              alignItems={'flex-start'}
              sx={{
                color: 'text.secondary',
                // display: 'flex',
                // flexDirection: 'column',
                // justifyContent: 'space-between',
                // alignItems: 'flex-start',
                // flexGrow: 1,
                // flexBasis: '30%',
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                Social
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Facebook
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Telegram
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link color="inherit"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer">
                  Twitter
                </Link>
              </Typography>
            </Stack> */}
          {/* </Grid> */}

          <Grid item xs={12} sm={12} md={12} xl={12}>
            <Stack
              direction="column"
              // spacing={{ xs: 1, sm: 2, md: 4 }}
              sx={{
                alignItems: { xs: 'center', sm: 'center' },
              }}>
              <Typography variant="subtitle1" mb={1} fontWeight={'bold'}>
                <Localized id="footer_contact_us">
                  Contact Us
                </Localized>
              </Typography>
              {/* <Typography variant="subtitle2">
                Dubai Silicon Oasis, Dubai, UAE
              </Typography> */}
              {/* <Typography variant="subtitle2">
                <Link
                  color="inherit"
                  href="tel:+971509386505"
                  target="_blank"
                  rel="noopener noreferrer">
                  +971 50 938 6505
                </Link>
              </Typography> */}
              <Typography variant="subtitle2" mb={1}>
                <Localized id="footer_telegram_label">
                  Telegram:
                </Localized>
                {' '}
                <Link
                  color="inherit"
                  href={telegramBotLink}
                  target="_blank"
                  rel="noopener noreferrer">
                  @ucardonebot
                </Link>
              </Typography>
              <Typography variant="subtitle2">
                <Link
                  color="inherit"
                  href="mailto:contact@ucard.one"
                  target="_blank"
                  rel="noopener noreferrer">
                  contact@ucard.one
                </Link>
              </Typography>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      <Typography variant="subtitle1" sx={{
        width: '100%',
        pt: 2,
        borderTop: '1px solid #00000022',
      }}>
        <Localized id="footer_copyright">
          UCard, 2025
        </Localized>
      </Typography>
    </Stack>
  )
}

export default Footer;
